import { gql } from '@apollo/client';

export const APPROVAL_TYPE_DELETED = gql`
  subscription approvalTypeDeleted {
    approvalTypeDeleted {
      approvalTypeId
      siteId
    }
  }
`;
